import React from "react";
import {CustomRichTextFromMarkdown} from "@hapinest/theme";

export const getTrialCardSlider = (componentData) => {
    // Build cards-tiles
    const tiles = [];
    for (const el of componentData?.fields?.elements) {
        const resort = el?.fields?.resort?.fields;
        tiles.push({
            overtitle: resort?.quote,
            title: resort?.resortName,
            subtitle: getSubtitle(resort?.destination, resort?.resortName),
            image: {
                url: el?.fields?.image?.fields?.file?.url,
                title: el?.fields?.image?.fields?.title
            },
            chip: el?.fields?.tag?.fields?.title,

            content: <CustomRichTextFromMarkdown markdownString={el?.fields?.apartmentDescription} />,
            footer: {
                title: el?.fields?.exampleTrip?.fields?.title,
                subtitle: el?.fields?.exampleTrip?.fields?.subtitle
            }
        });
    }

    return {
        sliderTitle: componentData?.fields?.title,
        tiles,
        tileVariant: "trial"
    };
};

const getSubtitle = (destination, resortName) => {
    if (destination?.fields?.destination === resortName) {
        return destination?.fields?.country?.fields?.country;
    }
    else {
        return destination?.fields?.destination + ", " + destination?.fields?.country?.fields?.country;
    }
};
